import l from "./td-longtail-vue-components113.js";
/* empty css                              */
import i from "./td-longtail-vue-components98.js";
var o = function() {
  var t = this, e = t._self._c, a = t._self._setupProxy;
  return e("div", { staticClass: "get-app" }, [a.showAppstore ? e(a.LinkButton, { staticClass: "get-app__link get-app__link--ios", attrs: { href: t.linkApple, target: "_blank", "tealium-name": "download-app-apple-app-store", "no-styling": "", "tealium-suffix": t.tealiumSuffix, "aria-label": a.titleAppstore } }, [e(a.AppStoreIcon, { attrs: { "aria-hidden": "true" } })], 1) : t._e(), a.showPlaystore ? e(a.LinkButton, { staticClass: "get-app__link get-app__link--android", attrs: { href: t.linkGoogle, target: "_blank", "tealium-name": "download-app-google-play-store", "tealium-suffix": t.tealiumSuffix, "no-styling": "", "aria-label": a.titlePlaystore } }, [e(a.GooglePlayIcon, { attrs: { "aria-hidden": "true" } })], 1) : t._e()], 1);
}, r = [], n = /* @__PURE__ */ i(
  l,
  o,
  r,
  !1,
  null,
  "aec54170"
);
const u = n.exports;
export {
  u as default
};
